import { Marked } from "marked";
import DOMPurify from "dompurify";

const marked = new Marked({ gfm: true, breaks: true });

let hooksInstalled = false;
function installHooks() {
    if (hooksInstalled) return;
    hooksInstalled = true;
    DOMPurify.addHook("afterSanitizeAttributes", (node) => {
        if (node.tagName === "A" && node.getAttribute("href")) {
            node.setAttribute("target", "_blank");
            node.setAttribute("rel", "noopener noreferrer");
        }
    });
}

/** Render model markdown to sanitized HTML for {@html}. */
export function renderAssistantMarkdown(text) {
    installHooks();
    const html = marked.parse(String(text ?? ""), { async: false });
    return DOMPurify.sanitize(html, {
        FORBID_TAGS: ["style", "img", "iframe", "form", "input", "button"],
        FORBID_ATTR: ["style"],
    });
}
